import React from 'react';
import './PeriodToggle.css'; // Reuse existing styles

export type TeamAIPeriodMode = 'last-4-weeks' | 'current-board';

interface TeamAIPeriodToggleProps {
  currentMode: TeamAIPeriodMode;
  onModeChange: (mode: TeamAIPeriodMode) => void;
  disabled?: boolean;
}

const TeamAIPeriodToggle: React.FC<TeamAIPeriodToggleProps> = ({ 
  currentMode, 
  onModeChange, 
  disabled = false 
}) => {
  const handleToggleClick = (mode: TeamAIPeriodMode) => {
    if (!disabled && mode !== currentMode) {
      console.log('🏆 [TEAM-AI-PERIOD-TOGGLE] Switching to:', mode);
      onModeChange(mode);
    }
  };

  return (
    <div className={`period-toggle ${disabled ? 'disabled' : ''}`}>
      <div className="period-toggle-label">Time Period:</div>
      <div className="period-toggle-buttons">
        <button
          type="button"
          className={`period-button ${currentMode === 'last-4-weeks' ? 'active' : ''}`}
          onClick={() => handleToggleClick('last-4-weeks')}
          disabled={disabled}
          title="Show last 4 complete weeks (excluding current incomplete week)"
        >
          📅 Last 4 Full Weeks
        </button>
        <button
          type="button"
          className={`period-button ${currentMode === 'current-board' ? 'active' : ''}`}
          onClick={() => handleToggleClick('current-board')}
          disabled={disabled}
          title="Show current 4-week rolling period (including current week if in progress)"
        >
          🔴 Current Board
        </button>
      </div>
    </div>
  );
};

export default TeamAIPeriodToggle;
